import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";
import employeesService from "presentation/services/employees";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import EmployeeForm from 'presentation/pages/employees/elements/form';

import { handleChange, getGender, getDocumentFieldType, dateIsInvalid } from "presentation/utils/functions/generic";
import moment from "moment";

class EmployeeEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await employeesService.findById(id).then((result) => {
      var employeeInfo = {
        id: result.id,
        registration: result.registration,
        registrationDate: result.registrationDate != null ? moment(result.registrationDate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null
      }

      var genderId = typeof (result.person?.naturalPerson?.gender) === 'undefined' ? -1 : parseInt(result.person.naturalPerson?.gender);


      var documentFieldTypeInfo = result.person?.documentFieldType ? getDocumentFieldType(result.person?.documentFieldType.toString().toLowerCase()) : undefined;
      var documentFieldTypeId = typeof (documentFieldTypeInfo) === 'undefined' ? -1 : documentFieldTypeInfo.id;

      employeeInfo = {
        ...employeeInfo,
        personId: result.person.id,
        naturalPersonId: result.person?.naturalPerson?.id,
        userId: result.person.userId,
        name: result.person.name,
        displayName: result.person.displayName,
        gender: genderId,
        documentField: result.person.documentField,
        documentFieldType: documentFieldTypeId,
        birthdate: result.person?.naturalPerson?.birthdate != null ? moment(result.person?.naturalPerson?.birthdate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null
      }

      this.setState({ form: employeeInfo, loading: false });
    });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
    } = this.state.form;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let postData = this.state.form;
      postData.gender = "" + postData.gender;

      if (dateIsInvalid(postData.birthdate)) {
        postData.birthdate = null;
      }

      if (dateIsInvalid(postData.registrationDate)) {
        postData.registrationDate = null;
      }

      try {
        const response = await employeesService.update(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {

          this.goTo("/colaboradores");
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form } = this.state;
    let { handleSubmit } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <EmployeeForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default EmployeeEdit;
